import React from 'react'
import styled from 'styled-components'
import { ProfileClub } from '../../../../data/profile/data-types'
import { up } from 'styled-breakpoints'
import { StatusEnum } from '../../../../data/book/data-types'
import { Link } from 'react-router-dom'

type ProfileClubProps = {
  club: ProfileClub
}

const ProfileClubCard: React.FunctionComponent<ProfileClubProps> = ({ club }) => (
  <Container to={`/messages/club/cafe/${club.id}`}>
    <Status statusId={club.status_id}/>
    <Image bg={club.image} />
    <Title>{ club.title }</Title>
  </Container>
)

const Container = styled(Link)`
    position: relative;
    width: fit-content;

    display: grid;
    align-items: start;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    grid-gap: 24px;

    overflow: visible;
    cursor: pointer;

    &, &:visited, &:active {
      text-decoration: none;
    }
`

const Status = styled.div<{ statusId: StatusEnum }>`
    position: absolute;
    bottom: 100%;
    left: 100%;
    transform: translate(-80%, 80%);

    width: 20px;
    height: 20px;

    background: ${p => p.theme.statuses[p.statusId]};
    
    border: 2px solid #F3F6FB;
    border-radius: 50%;
`

const Image = styled.div<{ bg: string | null }>`
    width: 136px;
    aspect-ratio: 6 / 9;

    border-radius: 10px;
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.1);

    background: url("${p => p.bg}");
    background-size: cover;

    ${up('tablet')} {
        width: 152px;
    }

    ${up('desktop')} {
        width: 179px;
    }
`

const Title = styled.div`
    color: ${p => p.theme.colors.main};
    height: 56px;

    font-size: 16px;
    font-weight: 600;
    line-height: 28px;

    overflow-y: hidden;
`

export default ProfileClubCard